/* Generado por generar_tabla_zebra.py. NO editar a mano:
   se deriva del catalogo y solo incluye prefijos 100% puros.
   Regenerar con: py generar_tabla_zebra.py --escribir */
window.TABLA_ZEBRA = {
 "ZD2204": {
  "handle": "zebra-zd220",
  "modelo": "ZD220"
 },
 "ZD2304": {
  "handle": "zebra-zd230",
  "modelo": "ZD230"
 },
 "ZD23W4": {
  "handle": "zebra-zd230",
  "modelo": "ZD230"
 },
 "ZD41H2": {
  "handle": "",
  "modelo": "ZD410"
 },
 "ZD4204": {
  "handle": "zebra-zd420",
  "modelo": "ZD420"
 },
 "ZD42H4": {
  "handle": "",
  "modelo": "ZD420HC"
 },
 "ZD4A02": {
  "handle": "zebra-zd411",
  "modelo": "ZD411"
 },
 "ZD4A04": {
  "handle": "zebra-zd421",
  "modelo": "ZD421"
 },
 "ZD4AH2": {
  "handle": "zebra-zd411",
  "modelo": "ZD411"
 },
 "ZD4AH4": {
  "handle": "zebra-zd421",
  "modelo": "ZD421"
 },
 "ZD5101": {
  "handle": "",
  "modelo": "ZD510"
 },
 "ZD62H4": {
  "handle": "",
  "modelo": "ZD620"
 },
 "ZD6A02": {
  "handle": "zebra-zd611",
  "modelo": "ZD611"
 },
 "ZD6A04": {
  "handle": "zebra-zd621",
  "modelo": "ZD621"
 },
 "ZD6A12": {
  "handle": "zebra-zd611",
  "modelo": "ZD611"
 },
 "ZD6A14": {
  "handle": "zebra-zd621",
  "modelo": "ZD621"
 },
 "ZD6AH2": {
  "handle": "zebra-zd611",
  "modelo": "ZD611"
 },
 "ZD6AH4": {
  "handle": "zebra-zd621",
  "modelo": "ZD621"
 },
 "ZE5114": {
  "handle": "zebra-ze511",
  "modelo": "ZE511"
 },
 "ZE5216": {
  "handle": "zebra-ze521",
  "modelo": "ZE521"
 },
 "ZT1114": {
  "handle": "zebra-zt111",
  "modelo": "ZT111"
 },
 "ZT2204": {
  "handle": "zebra-zt220",
  "modelo": "ZT220"
 },
 "ZT2314": {
  "handle": "zebra-zt231",
  "modelo": "ZT231"
 },
 "ZT4104": {
  "handle": "",
  "modelo": "ZT410"
 },
 "ZT4114": {
  "handle": "zebra-zt411",
  "modelo": "ZT411"
 },
 "ZT4216": {
  "handle": "zebra-zt421",
  "modelo": "ZT421"
 },
 "ZT5104": {
  "handle": "zebra-zt510",
  "modelo": "ZT510"
 },
 "ZT6104": {
  "handle": "zebra-zt610",
  "modelo": "ZT610"
 },
 "ZT61A4": {
  "handle": "zebra-zt610",
  "modelo": "ZT610"
 },
 "ZT6206": {
  "handle": "zebra-zt620",
  "modelo": "ZT620"
 }
};
